import React from "react";
import { SvgIcon, useTheme } from "@material-ui/core";

const AIJobCreationIcon = (props) => {
  const theme = useTheme();
  const secondaryColor = theme.palette.secondary.main;

  return (
    <SvgIcon {...props} viewBox="0 0 48 48">
      {/* Main sparkles */}
      <path
        d="M24 3L27.5 15L39 18L27.5 21L24 33L20.5 21L9 18L20.5 15L24 3Z"
        fill="currentColor"
      />
      <path
        d="M38 28L39.5 34.5L46 36L39.5 37.5L38 44L36.5 37.5L30 36L36.5 34.5L38 28Z"
        fill="currentColor"
      />
      <path
        d="M10 28L11.2 32.5L16 33.8L11.2 35L10 40L8.8 35L4 33.8L8.8 32.5L10 28Z"
        fill="currentColor"
      />

      {/* Plus badge with theme secondary color */}
      <circle
        cx="38"
        cy="10"
        r="8"
        fill={props.disableFill ? "" : secondaryColor}
      />
      <path
        d="M38 6V10M38 10V14M38 10H34M38 10H42"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </SvgIcon>
  );
};

export default AIJobCreationIcon;
